import _ from 'lodash'
import FieldGroupFormatter from './FieldGroupFormatter';

class RetroScreen extends FieldGroupFormatter {
  
  formatFieldsToScreen(fields, valueFieldType) {
    _.each(fields, (field) => {
      field.toFieldIdType = valueFieldType
      field.toFieldId = field.cac_codigo
      field.fromSectionFieldType = this.formatType(field.cac_tipocampo)
      delete field.cac_codigo
      delete field.cac_tipocampo
    })
    return fields
  }

}

export default new RetroScreen